import styled from 'styled-components';
import HeadingProps from './types';
import { helperStyles } from '../../const/helpers';
import { headingSize as s } from './const';
import { font } from '../../const/font';

export const HeadingStyled = styled.h1<HeadingProps>`
  font-family: ${({ $fontFamily }) => ($fontFamily ? font.family[$fontFamily] : font.family.aeonikRegular)}};
  font-size: ${({ $size }) => s[$size].fontSize}px;
  line-height: ${({ $size }) => s[$size].lineHeight}px;
  font-weight: ${({ $size }) => s[$size].fontWeight};
  margin-bottom: 16px;
  ${({ as: _as, $size: _size, ...rest }) => helperStyles(rest)}
  ${({ oneRow }) => oneRow && 'white-space: nowrap; overflow: hidden; text-overflow: ellipsis; position: relative;'}
`;

export default HeadingStyled;
